<template>
  <div class="wbs-form-header" :class="classe">
    <h5 class="wbs-form-header__titulo">
      <i v-bind:class="icon" v-if="icon"></i>
      {{ titulo }}
    </h5>
    <div class="wbs-form-header__actions">
      <slot name="actions"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "appFormCabecalho",
  props: {
    titulo: {
      type: String,
      required: true
    },
    classe: { type: String },
    icon: { type: String }
  }
};
</script>
<style lang="scss">
.wbs-form-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 10px;

  @include element("titulo") {
    margin-right: auto;
    margin-bottom: 0;
  }

  @include element("actions") {
    @include media-breakpoint-down(sm) {
      flex: 1;
      margin-top: 0.3rem;
      .btn {
        display: block;
        width: 100%;
      }
    }
  }
}
</style>
